import React, { useState } from 'react';
import Widget from '../Widget';
import WidgetTitle from '../WidgetTitle';
import { USDollar } from '/src/utilities/formats';


export default function ResearchActivityDesignation({ institutionData, updateTab }) {

    const RDtotal = institutionData.post_meta.rd_total_count.value;
    const RDspending = institutionData.post_meta.rd_total_spend.value;

    return (
        <Widget className="institutional-classification background-white">
            <div className="row" style={{ minHeight: '180px' }}>
                <div className='d-flex justify-content-center p-3'>
                    <div className='d-flex flex-column'>
                        {RDtotal &&
                            <div className='d-flex justify-content-center align-items-center'>
                                <div className='py-0 px-3'>
                                    <img src="/wp-content/plugins/ace-carnegie-institution-charts/frontend/src/images/widgets/research-activity-designation/icon-research-doctorates.svg"
                                        alt="Research Activity Designation" width="63" hieght="63" />
                                </div>
                                <div style={{ width: '200px' }}>
                                    <h4 className='mb-0'>
                                        {RDtotal}
                                    </h4>
                                    <div>Research Doctorates</div>
                                </div>
                            </div>
                        }
                        {RDspending &&
                            <div className='d-flex justify-content-center align-items-center'>
                                <div className='py-2 px-3'>
                                    <img src="/wp-content/plugins/ace-carnegie-institution-charts/frontend/src/images/widgets/research-activity-designation/icon-research-spending.svg"
                                        alt="Research Activity Designation" width="63" hieght="63" />
                                </div>
                                <div style={{ width: '200px' }}>
                                    <h4 className='mb-0'>
                                        {USDollar.format(RDspending)}
                                    </h4>
                                    <div>Research Spending</div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div className="row border-top pt-3 px-3">
                <div className="col-9">
                    <WidgetTitle>Research Activity Designation</WidgetTitle>
                </div>
                <div className="col-3">
                    <div className="d-flex justify-content-end">
                        <a href="#" onClick={(e) => updateTab('research')}>
                            <div className="circle-chev">
                                <img src="/wp-content/uploads/2023/01/arrow-right.svg" alt="" />
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <div className="row px-3">
                <div className="col-12">
                    {institutionData.post_meta.research2025.label}
                </div>
            </div>
        </Widget>
    );
}